function applySmartInputStyles(el, styleData = {}, isPaddingRequired = false, isDummyInput = false, clearAfterMs = 10000) {
  if (!el || !styleData) return;
  // Always clear previous styles first
  clearSmartInputStyles(el);

  const isPrioritySystem = styleData.CalculatedPriority ? true : false;

  // Apply background color and border
  el.style.backgroundColor = (styleData.colorCode && isPrioritySystem == false) ? styleData.colorCode + "1A" : styleData.colorCode ? styleData.colorCode : "";   // colorCode + "1A"  opacity (1A = ~10%)
  el.style.border = styleData.colorCode ? `2px solid ${styleData.colorCode}` : "";
  el.style.color = isPrioritySystem ? '#ffffff' : styleData.colorCode;
  el.style.boxShadow = `0 0 5px ${styleData.colorCode}, 0 0 5px ${styleData.colorCode}`;
  el.style.fontWeight = "600";

  if(isDummyInput){
    el.style.display = "inline-block";
    el.style.borderRadius = "4px";   // keep same rounded edges
    el.style.padding = "0.375rem 0.75rem"; // same as bootstrap input
  }

  if(styleData.icon){
    if(styleData.icon.startsWith("fa fa")){
      // Create and insert icon after input
      const iconEl = document.createElement("i");
      iconEl.className = `input-icon ${styleData.icon}`; // e.g. "fa fa-ship"

      // Position icon inside input
      iconEl.style.position = "absolute";
      iconEl.style.right = "0.75rem";
      iconEl.style.top = "50%";
      iconEl.style.transform = "translateY(-50%)";
      iconEl.style.color = styleData.colorCode ? styleData.colorCode : "#333";
      iconEl.style.fontSize = "1rem";
      iconEl.style.pointerEvents = "none";
      el.parentElement.style.position = "relative";

      // Add padding so text doesn't overlap the icon
      if(isPaddingRequired){
        const currentPaddingRight = parseFloat(window.getComputedStyle(el).paddingRight) || 0;
        iconEl.style.paddingRight = `${currentPaddingRight}px`;  
      }

      // Insert icon into the same container as the input
      el.insertAdjacentElement("afterend", iconEl);
      
    } else{
      const iconPath = styleData.icon.split("/").pop();
      el.style.backgroundImage = `url('/static/img/${iconPath}')`;;
      el.style.backgroundRepeat = "no-repeat";
      el.style.backgroundPosition = "right 0.5rem center";
      el.style.backgroundSize = "1.2rem";  
    }
  }
  else if (styleData.svgUrl) {
    // Encode inline SVG for safe CSS usage
    const encodedSvg = encodeURIComponent(styleData.svgUrl).replace(/'/g, "%27").replace(/"/g, "%22");
    el.style.backgroundImage = `url("data:image/svg+xml,${encodedSvg}")`;
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundPosition = "right 0.75rem center";
    el.style.backgroundSize = "1rem";
  }

  //Auto clear styles after timeout
  if (clearAfterMs && typeof clearAfterMs === "number") {
    setTimeout(() => {
      clearSmartInputStyles(el);
    }, clearAfterMs);
  }
}

function clearSmartInputStyles(el) {
  if (!el) return;

  el.removeAttribute("style");
  /* above line can clear all css in one go but its commented out 
    to avoid removing other styles that might be applied in components 
  */

  // Remove any icon elements next to this input
  const icon = el.parentElement.querySelector(".input-icon");
  if (icon) icon.remove();
}

function createClearInputWatcher(refKey) {
  return {
    async handler(val) {
      if (!val || val === '') {
        clearSmartInputStyles(this.$refs[refKey]);

        // loop through all refs and clear those starting with "dummyShipInputBox"
        Object.keys(this.$refs).forEach(refName => {
          if (refName.startsWith("dummyShipInputBox")) {
            const ref = this.$refs[refName];
            if (ref && typeof ref.clearStyles === "function") {
              ref.clearStyles();
            }
          }
        });
      }
    },
    immediate: true
  };
}


module.exports = {
  applySmartInputStyles,
  clearSmartInputStyles,
  createClearInputWatcher
}


// WEBPACK FOOTER //
// ./src/common/inputStyleHelper.js